import { useContext, useEffect, useRef, useState } from "react";
import AuthContext from "../../../../contexts/authContext";
import useDarkMode from "../../../../hooks/useDarkMode";
import useSortableData from "../../../../hooks/useSortableData";
import PaginationButtons, { dataPagination } from "../../../PaginationButtons";
import { useFormik } from "formik";
import { getBatchByCourseId, getCourse, getDepartmentList, getSemester } from "../../../../services/master.service";
import { toasts } from "../../../../services/toast.service";
import { getColumnsForDataTable, getCurrentDateAndTime, getGraduationType, getSectionDetails, onlyAllowNumber, updateFilter } from "../../../../services/common.service";
import { getLicenseKey } from "../../../../services/application.settings";
import { showLoader } from "../../../../services/loader.services";
import PageWrapper from "../../../../layout/PageWrapper/PageWrapper";
import Page from "../../../../layout/Page/Page";
import Collapse from "../../../bootstrap/Collapse";
import Card, { CardActions, CardBody, CardHeader, CardLabel, CardSubTitle, CardTitle } from "../../../bootstrap/Card";
import FormGroup from "../../../bootstrap/forms/FormGroup";
import SearchableSelect from "../../../../common/components/SearchableSelect";
import Button, { ButtonGroup } from "../../../bootstrap/Button";
import OpenCardComponent from "../../../../common/components/OpenCardComponent";
import Icon from "../../../icon/Icon";
import NoDataMsg from "../../../../common/components/NoDataMsg";
import Input from "../../../bootstrap/forms/Input";
import AlertService from "../../../../services/AlertService";
import Checks from "../../../bootstrap/forms/Checks";
import { addStudentBulkFeeCollection, getFeeType, getStudentBulkFeeCollection, getStudentBulkFeeCollectionFeeReceipt, getStudentBulkFeesDetails } from "../../../../services/fee.service";
import Textarea from "../../../bootstrap/forms/Textarea";
import classNames from "classnames";
import { getFirstLetter } from "../../../../helpers/helpers";
import SubHeader, { SubHeaderLeft, SubheaderSeparator } from "../../../../layout/SubHeader/SubHeader";
import Modal, { ModalBody, ModalHeader } from "../../../bootstrap/Modal";
import { getCollegeDetails } from "../../../../services/college.service";
import CollegeLogo from "../../../../assets/logos/logo.jpg"
import { useReactToPrint } from "react-to-print";
import dayjs from "dayjs";
import { downloadPdfDocument } from "../../../../services/ExportService";
import './receipt.css'
import PayBulkFees from "./PayBulkFees";

const BulkFeesCollection = () => {

    useEffect(() => {
        getGraduationList();
        getDepartment();
        getSectionList();
        getFeeTypeList();
        getCollege();
    }, [])

    const { userAccountId, userTypeId } = useContext(AuthContext);
    const [departmentId, setDepartmentId] = useState<any>(Number)
    const [courseId, setCourseId] = useState<any>(Number)
    const [batchMasterId, setBatchMasterId] = useState<any>(Number)
    const [semesterDetailsId, setSemesterDetailsId] = useState<any>(Number)
    const [graduationTypeId, setGraduationTypeId] = useState<any>(Number)
    const [sectionDetailsId, setSectionDetailsId] = useState<any>(Number)
    const [feeTypeId, setFeeTypeId] = useState<any>(Number)

    const [departmentData, setDepartmentData] = useState<any>([])
    const [courseData, setCourseData] = useState<any>([])
    const [graduationTypeData, setGraduationTypeData] = useState<any>([])
    const [batchMasterData, setBatchMasterData] = useState<any>([])
    const [semesterDetailsData, setSemesterDetailsData] = useState<any>([])
    const [sectionDetailsData, setSectionDetailsData] = useState<any>([])
    const [feesTypeData, setFeesTypeData] = useState([])

    const [isLoader, setIsLoader] = useState(false)

    const [studentFeeCollectionData, setStudentFeeCollectionData] = useState<any>([])
    const [nodataForPaidBills, setNodataForPaidBills] = useState('')
    const [columnVisibilityDataForFeeCollection, setColumnVisibilityDataForFeeCollection] = useState([]);
    const [allColumnsData, setAllColumnsData] = useState([]);

    // For Table
    const [studentDetailsData, setStudentDetailsData] = useState<any>([])
    const [dataSuccess, setDataSuccess] = useState(false)
    const [isOpenListCard, setIsOpenListCard] = useState(true)
    const { themeStatus, darkModeStatus } = useDarkMode();
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [receiptOpenModal, setReceiptOpenModal] = useState(false)

    const { items: items1, requestSort: requestSort1, getClassNamesFor: getClassNamesFor1 } = useSortableData(studentDetailsData);
    const { items: items, requestSort: requestSort, getClassNamesFor: getClassNamesFor } = useSortableData(studentFeeCollectionData);

    const onCurrentPageData1 = dataPagination(items1, currentPage, perPage);
    const onCurrentPageData = dataPagination(items, currentPage, perPage);

    const [studentFeeReceiptData, setStudentFeeReceiptData] = useState<any>([])
    const [receiptDetailsForStudent, setReceiptDetailsForStudent] = useState<any>([])
    const componentRef = useRef(null);
    const [collegeDetailsData, setCollegeDetailsData] = useState<any>([])
    const tableFontSize = 'fs-4';

    const [showPayFees, setShowPayFees] = useState(false)

    const TABSFORBULK = {
        FEE_DETAILS: 'Pay Fees',
        PAID: 'Paid Bills'
    };
    const [activeTabForBulk, setActiveTabForBulk] = useState(TABSFORBULK.PAID);

    // For Alert
    const [alertStatus, setAlertStatus] = useState<any>({ message: "", type: "" });
    const [isOpen, setIsOpen] = useState(false);

    const [noDataMsg, setNoDataMsg] = useState('')

    const columnVisibilityForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            searchInput: '',
            available: false,
        },
        validate: (values) => { },
        //validateOnChange: false,
        onSubmit: () => { },
    });

    // Filter
    const filteredData = updateFilter(onCurrentPageData, columnVisibilityDataForFeeCollection, columnVisibilityForm);

    const selectDepartment = (e: any) => {
        setGraduationTypeId('')
        setCourseId('')
        setCourseId('')
        setBatchMasterId('')
        setSemesterDetailsId('')
        setSectionDetailsId('')
        setFeeTypeId('')
        setDataSuccess(false);
        let departmentId = e
        setDepartmentId(departmentId)
    }

    const selectGraduationType = (e: any) => {
        setCourseId('')
        setBatchMasterId('')
        setSemesterDetailsId('')
        setSectionDetailsId('')
        setFeeTypeId('')
        setDataSuccess(false);
        let graduationTypeId = e
        setGraduationTypeId(graduationTypeId)
        if (graduationTypeId?.value != undefined) {
            getCourseList(departmentId?.value, graduationTypeId?.value)
        }
    }

    const selectCourse = (e: any) => {
        setBatchMasterId('')
        setSemesterDetailsId('')
        setSectionDetailsId('')
        setFeeTypeId('')
        setDataSuccess(false);
        let courseId = e
        setCourseId(courseId)
        if (courseId?.value != undefined) {
            getBatchList(courseId?.value, graduationTypeId?.value)
        }
    }

    const selectBatch = (e: any) => {
        setSemesterDetailsId('')
        setSectionDetailsId('')
        setFeeTypeId('')
        setDataSuccess(false);
        let batchMasterId = e
        setBatchMasterId(batchMasterId)
        if (batchMasterId?.value != undefined) {
            getSemesterList(batchMasterId?.value)
        }
    }

    const selectSemester = (e: any) => {
        setSectionDetailsId('')
        setFeeTypeId('')
        setDataSuccess(false);
        let semesterDetailsId = e
        setSemesterDetailsId(semesterDetailsId)
    }

    const selectSection = (e: any) => {
        setFeeTypeId('')
        let sectionDetailsId = e
        setSectionDetailsId(sectionDetailsId)
    }

    function viewStudentList() {
        setDataSuccess(false);
        setIsLoader(true);
        columnVisibilityForm.resetForm();
        getStudentBulkFeeCollectionList(courseId?.value, semesterDetailsId?.value, sectionDetailsId?.value, feeTypeId?.value)
    }

    function getDepartment() {
        getDepartmentList(
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.department;
                    if (data != undefined) {
                        setDepartmentData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    //toasts(response.data.message, "Error")
                    setDepartmentData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getGraduationList() {
        getGraduationType(
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.graduationType;
                    if (data != undefined) {
                        setGraduationTypeData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    //toasts(response.data.message, "Error")
                    setGraduationTypeData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getCourseList(departmentId: number, graduationTypeId: number) {
        getCourse(departmentId, graduationTypeId,
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.course;
                    if (data != undefined) {
                        setCourseData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    //toasts(response.data.message, "Error")
                    setCourseData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getBatchList(courseId: number, graduationTypeId: number) {
        getBatchByCourseId(courseId, graduationTypeId,
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.batchByCourseId;
                    if (data != undefined) {
                        setBatchMasterData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    //toasts(response.data.message, "Error")
                    setBatchMasterData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getSemesterList(batchMasterId: number) {
        getSemester(batchMasterId,
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.semester;
                    if (data != undefined) {
                        setSemesterDetailsData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    // toasts(response.data.message, "Error")
                    setSemesterDetailsData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getSectionList() {
        getSectionDetails(
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.sectionDetails;
                    if (data != undefined) {
                        setSectionDetailsData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    //toasts(response.data.message, "Error")
                    setSectionDetailsData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getFeeTypeList() {
        getFeeType(
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.feeType;
                    if (data != undefined) {
                        setFeesTypeData(data);

                    } else {
                        toasts("Undefined Data", "Error")
                    }
                } else if (response.data.success === false) {
                    toasts(response.data.message, "Error")
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getStudentBulkFeeCollectionList(courseId: number, semesterDetailsId: number, sectionDetailsId: number, feeTypeId: number) {
        getStudentBulkFeeCollection(courseId, semesterDetailsId, sectionDetailsId, feeTypeId,
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.studentBulkFeeCollection;
                    if (data != undefined) {
                        getColumnsForTableStudentFeeCollection('getStudentFeeCollection', 'get')
                        setStudentFeeCollectionData(data);
                        for (let i = 0; i < data.length; i++) {
                            data[i].sno = i + 1;
                        }
                        setIsLoader(false);
                        setIsOpenListCard(false);
                        setDataSuccess(true);
                        setShowPayFees(false);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    //toasts('Fees Not Collected Yet.', "Error")
                    getColumnsForTableStudentFeeCollection('getStudentFeeCollection', 'get')
                    setStudentFeeCollectionData([]);
                    setNodataForPaidBills('Fees Not Collected Yet.')
                    setDataSuccess(true);
                    setIsLoader(false);
                    setIsOpenListCard(false);
                    setShowPayFees(false);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getFeeReceipt(courseId: number, semesterDetailsId: number, sectionDetailsId: number, feeTypeId: number, studentFeeCollectionId: number) {
        getStudentBulkFeeCollectionFeeReceipt(courseId, semesterDetailsId, sectionDetailsId, feeTypeId, studentFeeCollectionId,
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.studentBulkFeeCollection;
                    let feeCollectionDetails = data[0].feeCollectionDetails
                    if (data != undefined) {
                        for (let i = 0; i < data.length; i++) {
                            let feeCollectionDetails = data[i].feeCollectionDetails
                            data[i].sno = i + 1;
                            for (let j = 0; j < feeCollectionDetails.length; j++) {
                                feeCollectionDetails[j].sno = j + 1;
                            }
                        }
                        setStudentFeeReceiptData(data);
                        setReceiptDetailsForStudent(feeCollectionDetails)
                        setReceiptOpenModal(true)
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    setStudentFeeReceiptData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function getColumnsForTableStudentFeeCollection(apiName: any, type: any) {
        getColumnsForDataTable(userTypeId, apiName,
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.columnsForDataTable;
                    if (data != undefined) {
                        let allColumnsData = data;
                        setAllColumnsData(allColumnsData)
                        let columnVisibilityDataForFeeCollection = allColumnsData.filter((item: any) => item.isDisplay == 1);
                        setColumnVisibilityDataForFeeCollection(columnVisibilityDataForFeeCollection)

                        if (type == 'get') {
                            const allData = allColumnsData.map((item: any) => item.isDisplay);
                            const allColumns = allData.filter((item: any) => item == false);
                            // setIsChecked(allColumns == '' ? true : false);
                        }
                        else if (type == 'post') {
                            const all = [];
                            let nonDefaultValue = allColumnsData.filter((item: any) => item.isDefault == false)

                            for (let i = 0; i < nonDefaultValue.length; i++) {

                                const obj = {
                                    columnVisibilityId: nonDefaultValue[i].columnVisibilityId,
                                    isDisplay: nonDefaultValue[0].isDisplay == 0 ? 1 : 0
                                }
                                all.push(obj);
                            }
                            // updateColumnsSubmit('', '', all)
                        }
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    toasts(response.data.message, "Error")
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )

    }

    function openPayFeesSection() {
        setDataSuccess(false);
        setIsLoader(true);
        columnVisibilityForm.resetForm();
        setShowPayFees(true);
    }

    const [pdfFileName, setPdfFileName] = useState('')

    function onActivate(i: any, text: any) {
        if (i != undefined) {
            let selectedStudent = i
            getFeeReceipt(courseId?.value, semesterDetailsId?.value, sectionDetailsId?.value, feeTypeId?.value, selectedStudent.studentBulkFeeCollectionId);
            setPdfFileName(selectedStudent.receiptNo)
        }
    }

    function getCollege() {
        getCollegeDetails(
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.collegeDetails;
                    if (data != undefined) {
                        setCollegeDetailsData(data);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    // toasts(response.data.message, "Error")
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    // Print
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    function handlePDF() {
        downloadPdfDocument(componentRef.current, pdfFileName)
    }

    function refreshAfterFeeCollection(msg: any) {
        if (msg != '') {
            viewStudentList()
            setAlertStatus({ message: msg, type: "success" });
            setIsOpen(true);
        } else {
            viewStudentList()
        }
    }

    return (
        <>

            {!showPayFees ?
                <PageWrapper title="Bulk Fees Collection">

                    <Page container='fluid'>
                        <Collapse isOpen={isOpenListCard}>
                            <Card stretch data-tour='list'>
                                <CardHeader borderSize={1}>
                                    <CardLabel icon='List' iconColor='info'>
                                        <CardTitle tag='div' className='h5'>
                                            Bulk Fees Collection
                                        </CardTitle>
                                    </CardLabel>
                                </CardHeader>
                                <CardBody>
                                    <div className="row g-4">
                                        <div className='col-md-3'>
                                            <FormGroup id='departmentId' label='Department' isFloating>
                                                <SearchableSelect isFloating
                                                    ariaLabel='Department'
                                                    onChange={selectDepartment}
                                                    value={departmentId}
                                                    list={departmentData.map((data: any) => (
                                                        { value: data.departmentId, label: data.departmentName }
                                                    ))}
                                                />
                                            </FormGroup>
                                        </div>

                                        {departmentId?.value != undefined ? <div className='col-md-3'>
                                            <FormGroup id='graduationTypeId' label='Graduation Type' isFloating>
                                                <SearchableSelect isFloating
                                                    ariaLabel='Graduation Type'
                                                    onChange={selectGraduationType}
                                                    value={graduationTypeId}
                                                    list={graduationTypeData.map((data: any) => (
                                                        { value: data.graduationTypeId, label: data.graduationType }
                                                    ))}
                                                />
                                            </FormGroup>
                                        </div> : null}

                                        {graduationTypeId?.value != undefined ? <div className='col-md-3'>
                                            <FormGroup id='courseId' label='Course' isFloating>
                                                <SearchableSelect isFloating
                                                    ariaLabel='Course'
                                                    onChange={selectCourse}
                                                    value={courseId}
                                                    list={courseData.map((data: any) => (
                                                        { value: data.courseId, label: data.courseName }
                                                    ))}
                                                />
                                            </FormGroup>
                                        </div> : null}

                                        {courseId?.value != undefined ? <div className='col-md-3'>
                                            <FormGroup id='batchMasterId' label='Batch' isFloating>
                                                <SearchableSelect isFloating
                                                    ariaLabel='Batch'
                                                    onChange={selectBatch}
                                                    value={batchMasterId}
                                                    list={batchMasterData.map((data: any) => (
                                                        { value: data.batchMasterId, label: data.batchName }
                                                    ))}
                                                />
                                            </FormGroup>
                                        </div> : null}

                                        {batchMasterId?.value != undefined ? <div className='col-md-3'>
                                            <FormGroup id='semesterDetailsId' label='Semester' isFloating>
                                                <SearchableSelect isFloating
                                                    ariaLabel='Semester'
                                                    onChange={selectSemester}
                                                    value={semesterDetailsId}
                                                    list={semesterDetailsData.map((data: any) => (
                                                        { value: data.semesterDetailsId, label: data.semesterNumber }
                                                    ))}
                                                />
                                            </FormGroup>
                                        </div> : null}

                                        {semesterDetailsId?.value != undefined ? <div className='col-md-3'>
                                            <FormGroup id='sectionDetailsId' label='Section' isFloating>
                                                <SearchableSelect isFloating
                                                    ariaLabel='Section'
                                                    onChange={selectSection}
                                                    value={sectionDetailsId}
                                                    list={sectionDetailsData.map((data: any) => (
                                                        { value: data.sectionDetailsId, label: data.sectionName }
                                                    ))}
                                                />
                                            </FormGroup>
                                        </div> : null}

                                        {sectionDetailsId?.value != undefined ? <div className='col-md-3'>
                                            <FormGroup id='feeTypeId' label='Fees Type' isFloating>
                                                <SearchableSelect isFloating
                                                    placeholder='Select Fee Type'
                                                    ariaLabel='Fees Type'
                                                    onChange={(e: any) => { setFeeTypeId(e) }}
                                                    value={feeTypeId}
                                                    list={feesTypeData.map((data: any) => (
                                                        { value: data.feeTypeId, label: data.feeType }
                                                    ))}

                                                />
                                            </FormGroup>
                                        </div> : null}

                                        {feeTypeId?.value != undefined ? <div className='col-3 mt-4'>
                                            <Button icon='ArrowDownward' color='primary' onClick={viewStudentList}>View</Button>
                                        </div> : null}
                                    </div>
                                </CardBody>
                            </Card>
                        </Collapse>

                        <OpenCardComponent isOpenListCard={isOpenListCard} setIsOpenListCard={setIsOpenListCard} isLoader={isLoader} />

                        {dataSuccess ?

                            <div className='row h-100 pb-3'>
                                <div className='col-lg-4 col-md-6'>
                                    <Card stretch>
                                        <CardHeader borderSize={1}>
                                            <CardLabel icon='Assignment' iconColor='info'>
                                                <CardTitle tag='div' className='h5'>
                                                    Fees Details
                                                </CardTitle>
                                                <CardSubTitle tag='div' className='h6'>
                                                    Fees Information
                                                </CardSubTitle>
                                            </CardLabel>
                                        </CardHeader>
                                        <CardBody>
                                            <div className='row g-3'>
                                                <div className='col-12'>
                                                    {/* {studentFeeCollectionData.map((student: any, index: any) => ( */}
                                                    <div className="row">
                                                        <div className="col-4">
                                                            <div className='flex-shrink-0'>

                                                                <div className='ratio ratio-1x1 me-3' style={{ width: 100 }}>
                                                                    <div
                                                                        className={classNames(
                                                                            'rounded-4',
                                                                            'd-flex align-items-center justify-content-center',
                                                                            {
                                                                                'bg-l10-dark': !darkModeStatus,
                                                                                'bg-l90-dark': darkModeStatus,
                                                                            },
                                                                        )}>
                                                                        <span className='fw-bold fs-2'>{feeTypeId?.label ? getFirstLetter(feeTypeId?.label) : feeTypeId?.label}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-8">
                                                            <h5 className='fs-5 fw-bold me-2'>{feeTypeId?.label}</h5>
                                                            <div className="text-info">{courseId?.label}</div>
                                                            {/* <div>{student.departmentName}</div> */}
                                                            <div className="text-danger">{batchMasterId?.label}</div>
                                                            <div>{semesterDetailsId?.label}</div>
                                                        </div>
                                                    </div>
                                                    {/* ))} */}

                                                </div>

                                                <div className='col-12'>
                                                    <Button
                                                        icon='PendingActions'
                                                        color='info'
                                                        className='w-100 p-3'
                                                        isLight={TABSFORBULK.PAID !== activeTabForBulk}
                                                        onClick={() => setActiveTabForBulk(TABSFORBULK.PAID)}>
                                                        {TABSFORBULK.PAID}
                                                    </Button>
                                                </div>
                                                <div className='col-12'>
                                                    <Button
                                                        icon='LocalPolice'
                                                        color='success'
                                                        className='w-100 p-3'
                                                        isLight={TABSFORBULK.FEE_DETAILS !== activeTabForBulk}
                                                        onClick={() => openPayFeesSection()}>
                                                        {TABSFORBULK.FEE_DETAILS}
                                                    </Button>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </div>
                                <div className='col-lg-8 col-md-6'>
                                    {TABSFORBULK.PAID === activeTabForBulk && (
                                        <Card stretch>
                                            <CardHeader>
                                                <CardLabel icon='PendingActions' iconColor='primary'>
                                                    <CardTitle tag='div' className='h5'>
                                                        Paid Bill Details
                                                    </CardTitle>
                                                    <CardSubTitle tag='div' className='h6'>
                                                        Total Bills:{' '}
                                                        <small className='ms-2'>
                                                            {filteredData.length}
                                                        </small>
                                                    </CardSubTitle>
                                                </CardLabel>
                                                {studentFeeCollectionData != "" ?
                                                    <CardActions>
                                                        <ButtonGroup className="col-lg-12 d-print-none" color='primary'>
                                                            <Icon className="mt-1" icon='Search' size='2x' color='primary' />
                                                            <Input id='searchInput' type='search' placeholder='Search...' onChange={columnVisibilityForm.handleChange} value={columnVisibilityForm.values.searchInput} />
                                                        </ButtonGroup>
                                                    </CardActions>
                                                    : null}
                                            </CardHeader>
                                            <CardBody className='table-responsive' isScrollable>
                                                <table className='table table-modern table-hover text-nowrap'>
                                                    <thead>
                                                        <tr>
                                                            <th scope='col' onClick={() => requestSort('sno')}
                                                                className='cursor-pointer text-decoration-underline'>S.No{' '}
                                                                <Icon size='lg' className={getClassNamesFor('sno')} icon='FilterList' />
                                                            </th>
                                                            {columnVisibilityDataForFeeCollection.map((column: any) => (
                                                                <th key={column.keyName} scope='col' onClick={() => requestSort(column.keyName)}
                                                                    className='cursor-pointer text-decoration-underline'>
                                                                    {column.columnName}
                                                                    <Icon size='lg' className={getClassNamesFor(column.keyName)} icon='FilterList' />
                                                                </th>
                                                            ))}
                                                            <td className="d-print-none" />
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {filteredData != "" ?
                                                            <>
                                                                {filteredData.map((rowData: any) => (<tr key={rowData.tempStudentDetailsId}><td>{rowData.sno}</td>{columnVisibilityDataForFeeCollection.map((column: any) => ((column.isDisplay && rowData[column.keyName]) ?
                                                                    <td key={`${rowData.tempStudentDetailsId}-${column.keyName}`}>{rowData[column.keyName]}</td> : <td key={`empty-${column.keyName}`} />))}
                                                                    <td className="d-print-none">
                                                                        <Button icon="Print" isLight color="info" onClick={() => onActivate(rowData, '')}>Print</Button></td>

                                                                </tr>))}</>
                                                            :
                                                            <NoDataMsg columnsCount={columnVisibilityDataForFeeCollection.length + 2} msg={nodataForPaidBills} />}

                                                    </tbody>
                                                </table>
                                            </CardBody>
                                            {studentFeeCollectionData != "" ? <PaginationButtons
                                                data={items}
                                                label='items'
                                                setCurrentPage={setCurrentPage}
                                                currentPage={currentPage}
                                                perPage={perPage}
                                                setPerPage={setPerPage}
                                            /> : null}
                                        </Card>
                                    )}
                                </div>
                            </div> : null}
                    </Page>

                    <style type="text/css" media="print">
                        {"@page { size: A4 landscape; margin-left: 0.5in; margin-right: 0.5in; margin-top: 0.5in; margin-bottom: 0.5in; }\ }"}
                    </style>

                    <Modal setIsOpen={setReceiptOpenModal} isOpen={receiptOpenModal} titleId='addCourseCapacity' isStaticBackdrop size='xl'>
                        <ModalHeader className="'modal-header'" setIsOpen={() => { setReceiptOpenModal(false) }}>
                            <div className='d-flex col-4'>
                                <Button size='sm' icon="Downloading" isLight color="success" onClick={handlePDF}>Download</Button>

                                <Button className="ms-2" size='sm' icon="Print" isLight color="primary" onClick={handlePrint}>Print</Button>
                            </div>
                        </ModalHeader>

                        <ModalBody ref={componentRef}>
                            {studentFeeReceiptData.map((studentFeeData: any) => (
                                <div className="modal-body table-responsive" id='thForReceipt' key={studentFeeData.studentFeeCollectionId}>
                                    <table className="table table-border border border-black table-responsive align-middle" style={{ fontFamily: 'Times New Roman' }} id="tdForReceipt">
                                        <tbody style={{ border: "1px solid black" }}>
                                            {collegeDetailsData.map((collegeData: any) => (
                                                <tr key={collegeData.collegeDetailsId}>
                                                    <td width="15%" rowSpan={1} align="center">
                                                        <img height="100px" width="100px"
                                                            src={CollegeLogo} />
                                                    </td>
                                                    <th style={{ width: '64%' }} className="text-center table-border border border-black" align="center">
                                                        <h2 className="text-uppercase" style={{
                                                            fontFamily: 'Bookman Old Style',
                                                            color: 'rgb(61, 57, 57)'
                                                        }}>
                                                            <b style={{ fontSize: '120%' }}>{collegeData.collegeName}</b>
                                                        </h2>

                                                        <b className="fs-7 mg-t-10" style={{ fontFamily: 'Bookman Old Style', color: 'rgb(61, 57, 57)', width: '95%' }}>
                                                            <p className="fs-6">({collegeData.description})<br />{collegeData.address}<br />
                                                                <Icon icon="Email" /> {collegeData.website} <Icon icon="Phone" /> {collegeData.phone} <Icon icon="PhoneAndroid" /> {collegeData.cellNo}</p>
                                                        </b>
                                                    </th>
                                                    <th style={{ width: '21%' }} className={tableFontSize} align="center">
                                                        <div className='align-middle'>
                                                            <p>Receipt No
                                                                : <strong>{studentFeeData.receiptNo}</strong></p>
                                                            <p className="mg-lg-t-5">Date
                                                                : <strong>{dayjs(studentFeeData.receiptDate).format('DD/MM/YYYY')}</strong></p>
                                                        </div>
                                                    </th>
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tbody>
                                            <tr>
                                                <td colSpan={3} align="center">

                                                    <div className="row mt-4 fs-4">
                                                        <div className="col-4">
                                                            <p>
                                                                <span style={{ float: 'left', marginLeft: '20px' }}>
                                                                    {/* Fee Type :
                                                                    <b>{studentFeeData.feeType}</b> */}
                                                                </span>
                                                            </p>
                                                        </div>
                                                        <div className="col-4">
                                                            <p>
                                                                <span>Fee Type :
                                                                    <b> {studentFeeData.feeType}</b>
                                                                </span>
                                                            </p>
                                                        </div>
                                                        <div className="col-4">
                                                            <p>
                                                                <span style={{ float: 'right', marginRight: '20px' }}>
                                                                    {/* Semester :
                                                                    <b> {studentFeeData.studentSemesterNumber}</b>*/}
                                                                </span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>

                                        <tbody>
                                            <tr className={tableFontSize}>
                                                <th className={'text-left border border-black'}>SI No.</th>
                                                <th className={'text-left border border-black'}>Particulars</th>
                                                <th className={'text-left border border-black'}>Amount</th>
                                            </tr>
                                            {/* {studentFeeData.feeCollectionDetails.map((feeData: any) => ( */}
                                            <tr className={tableFontSize}>
                                                <td className="text-left border border-black">
                                                    {studentFeeData.sno}
                                                </td>
                                                <td className="text-left border border-black">
                                                    {studentFeeData.studentCourseName} <span className="mt-3" style={{ float: 'right', marginRight: '30px' }}> Total Student :  <b>{receiptDetailsForStudent.length}</b></span> <br />
                                                    {studentFeeData.studentBatchName} - ({studentFeeData.studentSemesterNumber})
                                                </td>
                                                <td className="text-left border border-black">
                                                    <b>{studentFeeData.feesCollected}</b>
                                                </td>
                                            </tr>
                                            {/* ))} */}
                                            <tr className={tableFontSize}>
                                                <td></td>
                                                <td className="text-left border border-black align-middle">
                                                    Total amount
                                                </td>
                                                <td className="text-left border border-black">
                                                    <b> {studentFeeData.feesCollected}</b>
                                                </td>
                                            </tr>
                                            <tr className={tableFontSize}>
                                                <td colSpan={2} align="left" className="align-middle">
                                                    Amount in words : <b> {studentFeeData.feesCollectedInWords} Rupees Only/-</b>
                                                </td>
                                                <td align="left" className="align-middle" style={{ whiteSpace: 'nowrap' }}>
                                                    Payment Type: <b>{studentFeeData.paymentType}</b>
                                                </td>
                                            </tr>
                                            <tr id='tdForReceiptNoBorder' style={{ borderTopColor: 'white' }} className={tableFontSize}>
                                                <td style={{ borderRightColor: 'white', borderTopColor: 'white' }}></td>
                                                <td align="center"
                                                    style={{ borderRightColor: 'white', borderTopColor: 'white' }}>
                                                    <span style={{ float: 'left', marginLeft: '20px' }}>
                                                        <br />
                                                        <b>Seal</b>
                                                    </span>
                                                </td>
                                                <td aria-colspan={1} align="center">
                                                    <br />
                                                    <b>Signature</b>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    {studentFeeData.paymentTypeId > 4 ?
                                        <div className="row mt-4">
                                            <div className="col-12">
                                                <p>This is computer generated bill no signature required.</p>
                                            </div>
                                        </div> : null}
                                </div>
                            ))
                            }
                        </ModalBody>
                    </Modal>

                </PageWrapper>
                : <PayBulkFees departmentId={departmentId} courseId={courseId} batchMasterId={batchMasterId} semesterDetailsId={semesterDetailsId} graduationTypeId={graduationTypeId} sectionDetailsId={sectionDetailsId} feeTypeId={feeTypeId} setShowPayFees={setShowPayFees} showPayFees={showPayFees} refreshAfterFeeCollection={refreshAfterFeeCollection} />}

            <AlertService setIsOpen={setIsOpen} isOpen={isOpen} alertStatus={alertStatus} />
        </>
    )
}
export default BulkFeesCollection